import PropTypes from 'prop-types'

/**
 * @typedef {Object} ObjectMotionDetection
 * @property {Array<string>} controlFlags - List of current control flags
 * @property {boolean} enabled - The current (single) enabled state
 */
export const objectMotionDetectionPropType = PropTypes.shape({
    controlFlags: PropTypes.arrayOf(PropTypes.string),
    enabled: PropTypes.bool
})
